import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { useAnimationFrameSize } from "@/composables/sensors/animationFrameSize";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UnpairedDatasetElementView',
    props: {
        element: null,
        disabled: { type: Boolean, default: false },
        showExtension: { type: Boolean, default: true },
        showHid: { type: Boolean, default: true }
    },
    emits: ["element-is-selected"],
    setup(__props, { emit }) {
        const props = __props;
        const unpairedElement = ref(null);
        const elementName = ref(null);
        const { width: parentWidth } = useAnimationFrameSize(unpairedElement);
        const childWidth = computed(() => { var _a; return (_a = elementName.value) === null || _a === void 0 ? void 0 : _a.clientWidth; });
        const shouldMoveElement = computed(() => {
            if (childWidth.value && parentWidth.value && childWidth.value <= parentWidth.value) {
                return false;
            }
            else {
                return true;
            }
        });
        function getExtension() {
            return "extension" in props.element && props.element.extension ? props.element.extension : "";
        }
        return { __sfc: true, props, emit, unpairedElement, elementName, parentWidth, childWidth, shouldMoveElement, getExtension };
    }
});
